import type { ChipVariant } from '@/components/ui'
import type { AnswerChoice, ItemStatus, LibraryAction, QuestionnaireStage } from '../api/types'

export const STAGE_META: Record<QuestionnaireStage, { label: string; variant: ChipVariant }> = {
  extracting: { label: 'Reading', variant: 'info' },
  matching: { label: 'Answering', variant: 'info' },
  in_review: { label: 'In review', variant: 'warning' },
  approved: { label: 'Approved', variant: 'success' },
  sent: { label: 'Sent', variant: 'neutral' },
  failed: { label: 'Failed', variant: 'danger' },
}

export const STATUS_META: Record<
  ItemStatus,
  { label: string; variant: ChipVariant; hint: string }
> = {
  reused: {
    label: 'From library',
    variant: 'success',
    hint: 'An approved library answer, word for word',
  },
  adapted: {
    label: 'Check',
    variant: 'warning',
    hint: 'A library answer trimmed or less certain — check it fits',
  },
  drafted: {
    label: 'Drafted',
    variant: 'warning',
    hint: 'Drafted from the Quality Manual / SOPs — check it',
  },
  imported: {
    label: 'From form',
    variant: 'info',
    hint: 'The answer written on the uploaded form',
  },
  unanswered: {
    label: 'Needs answer',
    variant: 'danger',
    hint: 'Nothing in the library answers this',
  },
  accepted: { label: 'Reviewed', variant: 'success', hint: 'Accepted or written by a reviewer' },
}

export const CHOICE_LABEL: Record<AnswerChoice, string> = { yes: 'Yes', no: 'No', na: 'N/A' }

export const ACTION_LABEL: Record<LibraryAction, string> = {
  new: 'Add to library',
  variant: 'Same as library',
  update: 'Replace library answer',
  skip: "Don't save",
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  // Date-only strings are calendar dates: don't shift them through UTC.
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso)
  return d.toLocaleDateString()
}

export function isOverdue(due: string | null, stage: QuestionnaireStage): boolean {
  if (!due || stage === 'approved' || stage === 'sent') return false
  return new Date(`${due}T23:59:59`) < new Date()
}
